export default __webpack_public_path__ + "static/media/dp4.f6e5b7bd.png";